import React from 'react';
import { Row, Col } from 'react-bootstrap';
import './FullImageText.css'; // import your CSS file
import TextCaption from '../TextCaption/TextCaption';
import { useTranslation } from 'react-i18next';



const FullImageText = ({ imageSrc, altText, title, paragraph, imageWidth }) => {
    const { t } = useTranslation();

    const isMobile = window.innerWidth <= 768;
    // Calculate the actual width based on the input
    const getImageWidth = () => {
        switch (imageWidth) {
            case 1:

                return isMobile ? '100%' : '150%';
            case 2:
                return '100%';
            default:
                return '150%';
        }
    };



    // Check if image source and title are present
    const shouldRenderComponent = imageSrc && title;

    return shouldRenderComponent ? (
        <div className="full-image-text-container">
            <Row className="full-image-text-row">
                <Col md={6} className="full-image-text-column">
                    {/* Left column content */}
                    <div className="overlap-container">
                        <div className="image-wrapper" style={{ width: getImageWidth() }}>
                            <img src={imageSrc} alt={(t(altText))} className="full-image" />
                        </div>

                        {isMobile ? <></> : <>

                            <div className="flt-text-content-wrapper">
                                <TextCaption title={(t(title))} paragraph={(t(paragraph))} version={2} />
                            </div>
                        </>}
                    </div>
                </Col>
                <Col md={6} className="full-image-text-column">

                    {isMobile ? <>
                        <div className="flt-text-content-wrapper">
                            <TextCaption title={(t(title))} paragraph={(t(paragraph))} version={2} />
                        </div>
                    </> :
                        <></>}

                </Col>
            </Row>
        </div>
    ) : null;
};

export default FullImageText;
